module.exports = __webpack_public_path__ + "static/leaflet2025-ddaf2a3f87f2a1cf5a807e1da5e075c6.pdf";